import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'

const AddLevel = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  return (
    <FormField>
      <FormLabel isRequired>Уровень:</FormLabel>
      <FormInput isError={check('name')}>
        <input
          type='text'
          name='name'
          onChange={(e) => changeValues(e.target.value, 'name')}
          placeholder='Введите название уровня'
          value={modalValue?.name || ''}
          autoFocus
        />
      </FormInput>
    </FormField>
  )
}

export default observer(AddLevel)
